<bs-linear-container-stake [bsLinearStakeScroll]="'.betslip-edit-state__type-list'"></bs-linear-container-stake>
